<script setup>
import { ref } from 'vue'
import FileItem from './FileItem.vue'
import UrlItem from './UrlItem.vue'

const props = defineProps({
  cellInfo: {
    type: Object,
  },
  urls: {
    type: Array,
    required: false,
  },
  hideDelete: {
    type: Boolean,
    default: false,
  },
  hideDownload: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['download'])

const filesList = ref(props.cellInfo.value || [])
const urlsList = ref(props.urls || [])

const onRemove = (item) => { filesList.value = filesList.value.filter(f => f.name !== item.name) }

const onDownload = (item) => { emit('download', item) }

</script>

<template>
  <div>
    <q-list
      v-if="!dense"
      bordered
      separator
    >
      <FileItem
        v-for="item in filesList"
        :key="item.name"
        :item="item"
        :dense="dense"
        :hide-delete="hideDelete"
        :hide-download="hideDownload"
        @remove="onRemove"
        @download="onDownload"
      />
      <UrlItem
        v-for="urlItem in urlsList"
        :key="urlItem.url"
        :item="urlItem"
        :dense="dense"
        :hide-delete="hideDelete"
      />
    </q-list>
    <div v-else>
      <FileItem
        v-for="item in filesList"
        :key="item.name"
        :item="item"
        :dense="dense"
        :hide-delete="hideDelete"
        :hide-download="hideDownload"
        @remove="onRemove"
        @download="onDownload"
      />
      <UrlItem
        v-for="urlItem in urlsList"
        :key="urlItem.url"
        :item="urlItem"
        :dense="dense"
        :hide-delete="hideDelete"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>